module.exports = __webpack_public_path__ + "assets-customer/images/ring.gif?c70e6842";